module.exports = __webpack_public_path__ + "img/plus-white.355e1977.svg";